// extracted by mini-css-extract-plugin
module.exports = {"base":"planDetailBreadcrumb_base__O37jZ"};